import React, { FC, useId, useRef, useState } from 'react'
import {
  Container,
  Title,
  SubTitle,
  TitleWrapper,
  ErrorContainer,
  ErrorText,
  UploadedFileContainer,
  SubTitleWrapper,
  UploadInfoWrapper,
  FileNameWrapper,
  ProgressWrapper,
  ProgressBar,
  DragWrapper,
  FileText,
  BackGround,
  Overlay,
  Zirochka,
  FileInput,
  RemoveButton,
} from './styles'
import DocumentIcon from './document.svg'
import UploadedDocumentIcon from './uploaded-document.svg'
import Typography from '../typography'
import AlertIcon from './error.svg'
import { icons } from '../../icons'
import StyledIcon from '../styled-icon'
import { formatFileSize } from '../../utils/sizes'
import { BodySmallMedium } from '../typography/styled'
import { useTranslation } from 'react-i18next'



type DragOptions = {
  onChange:(file:any) => void,
  customStyles?:any,
  uploadedFile?:any,
  setStringSSh?:(value:string) => void,
  isSsh?:boolean,
  isImage?:boolean,
  formats?:string,
  fileValidation?:any,
  required?:boolean,
  requiredListener?:boolean,
  fieldName?:string,
  error?:any,
}
function endsWithOptions(str: string, options: string[]): boolean {
  for (const option of options) {
    if (str.endsWith(option)) {
      return true;
    }
  }
  return false;
}
const DragAndDrop:FC<DragOptions> = (props) => {
  const {
    onChange,
    customStyles,
    uploadedFile,
    setStringSSh,
    isSsh,
    formats,
    fileValidation,
    isImage,
    required,
    requiredListener,
    fieldName,
    error: formError,
  } = props
  // const inputRef:any = useRef()
  const [dragActive,  setDragActive] = React.useState(false);
  const [error, setError] = useState<string>('')
  const fileInputRef = useRef<HTMLInputElement>(null)
  const fileInputId = useId()
  const [t] = useTranslation()
  const updateSshContents = (file:File) => {
    if (!setStringSSh) {
      return
    }

    const reader = new FileReader()
    reader.onloadend = () => {
      if (typeof reader.result !== 'string') {
        return
      }

      const encodedContents = reader.result.split(',')[1]
      if (encodedContents) {
        const originalString = decodeURIComponent(escape(window.atob(encodedContents)))
        setStringSSh(originalString)
      }
    }
    reader.readAsDataURL(file)
  }
  const handleDrag = (e:any) => {
    e.preventDefault()
    e.stopPropagation()
  }
  const handleDragIn = (e:any) => {
    e.preventDefault()
    e.stopPropagation()
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      setDragActive(true)
    }
  }
  const handleDragOut = (e:any) => {
    e.preventDefault()
    e.stopPropagation()
    setDragActive(false)
  }
  const handleDrop = (e:any, isSelect?:boolean) => {
    e.preventDefault()
    e.stopPropagation()
    setDragActive(false)
    if(!isSelect){
      if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
        if(!e.dataTransfer.files[0].name.endsWith('.pub') && isSsh){
          setError(`${t("ERROR_UPLOAD_FILE_FORMAT_NOT_SUPPORTED")}`)
          return
        }
        if(isImage && !endsWithOptions(e.dataTransfer.files[0].name, fileValidation || [])){
          setError(`${t("ERROR_UPLOAD_FILE_FORMAT_NOT_SUPPORTED")}`)
          return
        }
        const file = e.dataTransfer.files[0]
        setError("")
        updateSshContents(file)
        onChange(e.dataTransfer.files[0])
        e.dataTransfer?.clearData()
      }
    } else {
        const file = e.target.files?.[0]
        if (!file) {
          return
        }
        if(!file.name.endsWith('.pub') && isSsh){
          setError(`${t("ERROR_UPLOAD_FILE_FORMAT_NOT_SUPPORTED")}`)
          return
        }
        if(isImage && !endsWithOptions(file.name, fileValidation || [])){
          setError(`${t("ERROR_UPLOAD_FILE_FORMAT_NOT_SUPPORTED")}`)
          return
        }
        setError("")
        updateSshContents(file)
        onChange(file)
        e.target.value = ''
      }

  }
  // function encryptMessage(message?:any, publicKey?:any) {
  //   const jsEncrypt = new JSEncrypt();
  //   jsEncrypt.setPublicKey(publicKey);
   
  //   return jsEncrypt.encrypt(message);
  // }
  const handleDeleteFile = () => {
    onChange(null)
    setDragActive(false)
    setStringSSh?.('')
  }
  const uploadProgress = typeof uploadedFile?.progress === 'number' && Number.isFinite(uploadedFile.progress)
    ? Math.min(100, Math.max(0, uploadedFile.progress))
    : undefined
  const hasUploadProgress = uploadProgress !== undefined
  return (
    <DragWrapper
      customStyles={customStyles}
      tabIndex={requiredListener || formError ? -1 : undefined}
      aria-invalid={Boolean(requiredListener || formError)}
      data-validation-field={fieldName}
      data-validation-error={requiredListener || formError ? true : undefined}
    >
      <FileText>
        {t("FILE")}{required ? <Zirochka>*</Zirochka> : null}
      </FileText>
      {uploadedFile ?
      
        <UploadedFileContainer>
          <ProgressWrapper>
            <UploadInfoWrapper>
              <img alt="" src={UploadedDocumentIcon}/>
              <FileNameWrapper>
                <BodySmallMedium style={{wordBreak:'break-all'}}>
                  {uploadedFile.name}
                </BodySmallMedium>
                <SubTitleWrapper>
                  <Typography variant='very-small'>
                    {formatFileSize(uploadedFile.size)}
                  </Typography>
                  {hasUploadProgress &&
                    <Typography variant='very-small'>
                      {Math.round(uploadProgress)}%{uploadedFile.timeLeft != null ? ` • ${uploadedFile.timeLeft}` : ''}
                    </Typography>
                  }
                </SubTitleWrapper>
              </FileNameWrapper>
            </UploadInfoWrapper>
            {hasUploadProgress &&
              <ProgressBar
                aria-label={`Uploading ${uploadedFile.name}`}
                value={uploadProgress}
                max={100}
              />
            }
          </ProgressWrapper>
          <RemoveButton type="button" aria-label={`${t("DELETE")} ${uploadedFile.name}`} onClick={handleDeleteFile}>
            <StyledIcon aria-hidden="true" src={icons.CloseIcon}/>
          </RemoveButton>
        </UploadedFileContainer>
      :
      <BackGround
        active={dragActive}
        onDragEnter={handleDragIn}
        onDragLeave={handleDragOut}
        onDragOver={handleDrag}
        onDrop={handleDrop}
      >
      <div style={{width: '100%'}}>
          <Container
            isError={error.length > 0}
            active={dragActive}
            onDragEnter={handleDrag}
          >
              <FileInput ref={fileInputRef} type='file' id={fileInputId} onChange={(e) => handleDrop(e, true)} />
              <img alt="" src={DocumentIcon}/>
              <TitleWrapper style={{display:'flex'}}>
              <Title>{t("CLICK_TO_UPLOAD")}</Title> &nbsp;
              <Typography variant='body'>
                {t("OR_DRAG")}
              </Typography>
              </TitleWrapper>
              <SubTitle>{formats ? formats : t("INFO_FILE_SIZE")}</SubTitle>
              <ErrorContainer isError={error.length > 0}>
                <img alt="" src={AlertIcon}/>
                <ErrorText>{error}</ErrorText>
              </ErrorContainer>
          </Container>
        </div>
        <Overlay
          htmlFor={fileInputId}
          role="button"
          tabIndex={0}
          aria-label={t("CLICK_TO_UPLOAD")}
          aria-invalid={Boolean(requiredListener || formError)}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault()
              fileInputRef.current?.click()
            }
          }}
        />
        </BackGround>
      // <div className="container">
      //   <div {...getRootProps({style})}>
      //     <input {...getInputProps()} />
      //     <p>Drag 'n' drop some files here, or click to select files</p>
      //   </div>
      // </div>
      // <Dropzone onDrop={acceptedFiles => console.log(acceptedFiles)}>
      //   {({getRootProps, getInputProps}) => (
      //     <section>
      //       <div {...getRootProps()}>
      //         <input {...getInputProps()} />
      //         <p>Drag 'n' drop some files here, or click to select files</p>
      //       </div>
      //     </section>
      //   )}
      // </Dropzone>
      }
      {requiredListener && <ErrorText style={{marginTop:'6px'}}>{t("FILE_REQUIRED")}</ErrorText>}
      {!requiredListener && formError && <ErrorText style={{marginTop:'6px'}}>{formError}</ErrorText>}
    </DragWrapper>
  )
}

export default DragAndDrop
